import { imageAssetUploadOptions } from "./assets";
import { FieldMediaAsset, type FieldMediaAssetProps } from "./FieldMediaAsset";
import type { ImageAssetValue } from "./types";

type FieldImageAssetProps = Omit<FieldMediaAssetProps<ImageAssetValue>, "uploadOptions" | "type"> & {
  uploadOptions?: FieldMediaAssetProps<ImageAssetValue>["uploadOptions"];
};

export const FieldImageAsset = ({ uploadOptions = imageAssetUploadOptions, ...props }: FieldImageAssetProps) => {
  return <FieldMediaAsset {...{ ...props, uploadOptions, type: "image" }} />;
};
